const PRODUCT_FADE_TRANSITION = 'product-fade-transition';
const PREFETCH_LIMIT = 2;
const prefetches = new Set();

function canUseProductFadeTransition() {
  return !window.matchMedia('(prefers-reduced-motion: reduce)').matches
    && !document.documentElement.classList.contains('shopify-design-mode');
}

function isPlainPrimaryClick(event) {
  return event.button === 0
    && !event.metaKey
    && !event.ctrlKey
    && !event.shiftKey
    && !event.altKey;
}

function markTransitionSource(card) {
  if (!canUseProductFadeTransition()) return;
  card.setAttribute('data-view-transition-type', PRODUCT_FADE_TRANSITION);
  card.setAttribute('data-view-transition-triggered', 'true');
}

function appendPrefetch(url, as) {
  if (!url || prefetches.has(url)) return;
  prefetches.add(url);

  const link = document.createElement('link');
  link.rel = 'prefetch';
  link.href = url;
  if (as) link.as = as;
  document.head.append(link);
}

function prefetchCollectionProducts() {
  const cards = [...document.querySelectorAll('[data-product-transition]')].slice(0, PREFETCH_LIMIT);
  const viewport = window.matchMedia('(min-width: 990px)').matches ? 'desktop' : 'mobile';
  const imageKey = `productPrefetchImage${viewport[0].toUpperCase()}${viewport.slice(1)}`;

  cards.forEach((card) => {
    if (!(card instanceof HTMLAnchorElement)) return;
    appendPrefetch(card.href, 'document');
    appendPrefetch(card.dataset[imageKey], 'image');
  });
}

document.addEventListener('click', (event) => {
  const card = event.target instanceof Element ? event.target.closest('[data-product-transition]') : null;
  if (!(card instanceof HTMLAnchorElement) || event.defaultPrevented || !isPlainPrimaryClick(event)) return;
  markTransitionSource(card);
}, true);

if (document.querySelector('[data-product-transition]')) {
  const schedule = window.requestIdleCallback || ((callback) => window.setTimeout(callback, 1));
  schedule(prefetchCollectionProducts, { timeout: 1500 });
}
